export const QA_NAME_LISTING_PROFILE_DOCUMENTS_TABLE = 'listingDocuments'

export const LISTING_PROFILE_DOCUMENTS_BREADCRUMB_LISTING = 'listing'
